module.exports = __webpack_public_path__ + "img/home-icon.a6ddbe96.svg";